export const TOTAL_SUPPLY = 100_000_000_000_000_000
